import { GetterTree } from 'vuex'
import DomainState from './states'
import { State } from '@/store/store'

const mockHeader = [
  {
    text: 'Name',
    value: 'name',
  },
  {
    text: 'Status',
    value: 'status',
  },
  {
    text: 'Create At',
    value: 'createdAt',
  },
  {
    text: 'Update At',
    value: 'updatedAt',
  },
  {
    text: 'Action',
    value: 'action',
  },
]

const getters: GetterTree<DomainState, State> = {
  domainLists: (state) => {
    return state.domain
  },
  domainAllLists: (state) => {
    return state.domain
  },
  headerLists: (state) => {
    return state.lists.column.length !== 0 ? state.lists.column : mockHeader
  },
  itemLists: (state) => {
    return state.lists.result
  },
  filterLists: (state) => {
    return state.lists.defaultFilter
  },
  pagination: (state) => {
    const paginationLists = {
      itemCount: state.lists.itemCount,
      page: state.lists.page,
      pageCount: state.lists.pageCount,
    }
    return paginationLists
  },
}

export default getters
